import type { ConversationResponse } from '@acme/api/admin';
import { formatDateLabel, startOfDayTs } from './format';

export interface ConversationSection {
  sectionLabel: string;
  items: ConversationResponse[];
}

export const groupConversationsByDay = (
  conversations: ConversationResponse[]
): ConversationSection[] => {
  const todayTs = startOfDayTs(new Date());

  const groups = new Map<
    string,
    { label: string; dayTs: number | null; items: ConversationResponse[] }
  >();

  for (const conversation of conversations) {
    const sentAt = conversation.lastMessage?.sentAt;
    const date = sentAt ? new Date(sentAt) : null;
    const dayTs = date ? startOfDayTs(date) : null;

    const isToday = dayTs === todayTs;
    const key = isToday ? 'today' : String(dayTs ?? 'unknown');
    const label = isToday ? 'Сегодня' : date ? formatDateLabel(date) : '—';

    const existing = groups.get(key);
    if (existing) {
      existing.items.push(conversation);
    } else {
      groups.set(key, { label, dayTs, items: [conversation] });
    }
  }

  const entries = Array.from(groups.entries());

  entries.sort((a, b) => {
    if (a[0] === 'today') return -1;
    if (b[0] === 'today') return 1;
    const aTs = a[1].dayTs ?? -Infinity;
    const bTs = b[1].dayTs ?? -Infinity;
    return bTs - aTs;
  });

  return entries.map(([, value]) => ({
    sectionLabel: value.label,
    items: value.items,
  }));
};
